import { memo, ReactNode } from 'react'

import rocketSvg from 'common/assets/img/illustration/rocket.svg'
import earthSvg from 'common/assets/img/illustration/earth.svg'
import moonSvg from 'common/assets/img/illustration/moon.svg'
import astrounatSvg from 'common/assets/img/illustration/logo_astronaut.svg'

export interface Props {
  children: ReactNode
}

const LostInSpace = ({ children }: Props) => (
  <div className="bg-purple">
    <div className="stars">
      <div className="central-body">{children}</div>
      <div className="objects">
        <img className="object_rocket" src={rocketSvg} />
        <div className="earth-moon">
          <img className="object_earth" src={earthSvg} />
          <img className="object_moon" src={moonSvg} />
        </div>
        <div className="box_astronaut">
          <img className="object_astronaut" src={astrounatSvg} />
        </div>
      </div>
      <div className="glowing_stars">
        <div className="star" />
        <div className="star" />
        <div className="star" />
        <div className="star" />
        <div className="star" />
      </div>
    </div>
  </div>
)

export default memo(LostInSpace)
